import { render, staticRenderFns } from "./QueryPolicyBody.vue?vue&type=template&id=675ce00f&"
import script from "./QueryPolicyBody.vue?vue&type=script&lang=js&"
export * from "./QueryPolicyBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports